import React from 'react';
import { InventoryTypeKey } from '~/constants/inventoryType';
import { getInventoryType } from '~/selectors';
import useSelector from '~/store/useSelector';

type OwnProps = React.PropsWithChildren<{
  inventoryType: InventoryTypeKey[];
}>;

export default function ShowForInventoryType(props: OwnProps) {
  const inventoryType = useSelector(getInventoryType);

  return props.inventoryType.includes(inventoryType) ? (
    <>{props.children}</>
  ) : null;
}
